export default __webpack_public_path__ + "static/media/grass.e09623e3.svg";